const state = {
    // 油卡列表
    oilCardList: [],
    // 油卡列表选中id
    oilCardId: -1
}
export default state